import * as React from 'react';
import './receiptInfoPane.module.scss';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { inject, observer } from 'mobx-react';
import { SettingPane } from '../../molecules/mypage/page';
import { FormInput } from '../../atoms/forms/FormInput';
import { observable, makeObservable } from 'mobx';
import { ReceiptInfoState } from './states/ReceiptInfoState';
import { SelectInput } from '../../atoms/forms/SelectInput';
import { Button } from '@sheinc/shelikes-design-system';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
  homeState: HomePageState;
  match: {
    params: {
      code: string;
    };
  };
};

export const ReceiptInfoPane = inject('homeState')(
  observer(
    class ReceiptInfoPane extends React.Component<Props> {
      pageState = new ReceiptInfoState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      componentDidMount(): void {
        this.pageState.init();
      }

      render() {
        const { submitting, formState } = this.pageState;
        const { code } = this.props.match.params;
        return (
          <SettingPane activeMenu="payments" title="領収書発行">
            <div styleName="form-label">宛名</div>
            <FormInput
              styleName="name"
              name="name"
              value={formState.getValue('name')}
              placeholder=""
              onChange={(e) => formState.setValue('name', e.target.value)}
              error={formState.getError('name')}
            />
            <SelectInput
              styleName="sm"
              id="appelation"
              value={formState.getValue('appelation')}
              onChange={(e) => formState.setValue('appelation', e)}
            >
              <option value="御中">御中</option>
              <option value="様">様</option>
            </SelectInput>
            <div styleName="form-label">但し書き</div>
            <FormInput
              styleName="purpose"
              name="purpose"
              value={formState.getValue('purpose')}
              placeholder=""
              onChange={(e) => formState.setValue('purpose', e.target.value)}
              error={formState.getError('purpose')}
            />
            <div styleName="form-submit-button">
              <Button
                isLoading={submitting}
                onClick={() => this.pageState.submit(code)}
                fullWidth={GlobalStatesV3.viewport.isSp}
              >
                領収書を発行する
              </Button>
            </div>
          </SettingPane>
        );
      }
    }
  )
);
